module.exports = __webpack_public_path__ + "media/images/icon-product/carboard-box-c3e7d72c632b5b392525b6cdd7d636bb.svg";